import { Suspense, lazy } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { Navigate, Outlet } from 'react-router';

import { LoginLayout, LoginPageCommon, LoginVerificationPageCommon } from '@zeta-commons';
import { LoadingScreen } from '@zeta-core';

const ChangePassword = lazy(() => import('../../pages/auth/change-password'));
const ForgotPassword = lazy(() => import('../../pages/auth/forgot-password'));
const ForgotUsername = lazy(() => import('../../pages/auth/forgot-username'));
const ResetPassword = lazy(() => import('../../pages/auth/forgot-password/reset-password'));
import { CompactErrorPage } from '../../layouts/compact-layout';

const AuthRoutes = [
  {
    path: 'auth',
    children: [
      {
        path: '',
        element: (
          <ErrorBoundary FallbackComponent={CompactErrorPage}>
            <LoginLayout>
              <Suspense fallback={<LoadingScreen />}>
                <Outlet />
              </Suspense>
            </LoginLayout>
          </ErrorBoundary>
        ),
        children: [
          {
            path: 'login',
            element: <LoginPageCommon registrationAllowed={true} />,
          },
          {
            path: 'verification',
            element: <LoginVerificationPageCommon />,
          },
          {
            path: 'forgot-password',
            element: (
              <Suspense fallback={<LoadingScreen />}>
                <ForgotPassword />
              </Suspense>
            ),
          },
          {
            path: 'forgot-username',
            element: (
              <Suspense fallback={<LoadingScreen />}>
                <ForgotUsername />
              </Suspense>
            ),
          },
          {
            path: 'reset-password',
            element: (
              <Suspense fallback={<LoadingScreen />}>
                <ResetPassword />
              </Suspense>
            ),
          },
          {
            path: 'change-password',
            element: (
              <Suspense fallback={<LoadingScreen />}>
                <ChangePassword />
              </Suspense>
            ),
          },
          {
            path: '',
            element: <Navigate to="login" replace />,
          },
        ],
      },
    ],
  },
];

export default AuthRoutes;
